import { TDivisionResponse, TDivisionResponsePaginated } from 'app/services/edpApiV1/moderator';
import { TableRowSelection } from 'antd/lib/table/interface';
import { Input, Pagination, Spin, Table } from 'antd';
import React, { FC, useEffect, useMemo, useState } from 'react';
import { TOrgDivResponse } from 'shared/types/poll.types';
import DivisionSearchSettings from '../divisionSearchSettings/DivisionSearchSettings';
import style from './index.module.scss';

type TDivisionsSearchProps = {
  selectedDivisions?: TDivisionResponse[];
  addDivisions: (users: TDivisionResponse[]) => void;
  getDivisionsQuery: (...args: any[]) => void;
  data?: TOrgDivResponse | TDivisionResponsePaginated;
  isFetching?: boolean;
  isActive?: boolean;
};

const columns = [
  {
    title: 'Наименование',
    dataIndex: 'name',
    key: 'name',
  },
];

const DivisionsSearch: FC<TDivisionsSearchProps> = ({
  addDivisions,
  selectedDivisions,
  getDivisionsQuery,
  data,
  isFetching,
  isActive,
}) => {
  const [page, setPage] = useState<number>(1);
  const [size, setSize] = useState<number>(10);

  const [searchOrganizationId, setSearchOrganizationId] = useState<string>();
  const [searchField, setSearchField] = useState<string>('');
  const [search, setSearch] = useState<string>('');

  useEffect(() => {
    if (searchOrganizationId) {
      getDivisionsQuery({ organizationId: searchOrganizationId, page, size, search: searchField });
    }
  }, [searchField, page, size]);

  useEffect(() => {
    if (isActive) {
      setSearchField('');
      setSearch('');
      setPage(1);
      setSize(10);
    }
  }, [isActive]);

  const selectedRowKeys: string[] = useMemo(() => {
    if (selectedDivisions) {
      return selectedDivisions.map(elem => elem.id);
    }
    return [];
  }, [selectedDivisions]);

  const rowSelection: TableRowSelection<TDivisionResponse> = {
    type: 'checkbox',
    selectedRowKeys,
    onChange: (selectedRowKeys: React.Key[], selectedRows: TDivisionResponse[]) => {
      const divisions = data?.data;

      if (!divisions) {
        return;
      }

      const pickedDivisions: TDivisionResponse[] = [];
      let newSelectedDivisions = [...(selectedDivisions || [])];

      for (const division of divisions) {
        let isEqual = false;
        for (const selectedUser of selectedRows) {
          if (division.id === selectedUser.id) {
            const userIsPicked = !!newSelectedDivisions.find(elem => elem.id === division.id);
            //Кидаем новое значение, если оно есть в выбранных на этой странице, но нет в выбранных в общем
            if (!userIsPicked) {
              pickedDivisions.push(selectedUser);
            }
            isEqual = true;
          }
        }
        // Если массив выбранных не содержит значение из массива с бека, удаляем его из выбранных
        if (!isEqual) {
          newSelectedDivisions = newSelectedDivisions.filter(elem => elem.id !== division.id);
        }
      }
      addDivisions([...pickedDivisions, ...(newSelectedDivisions || [])]);
    },
  };

  const handlePagination = (value: number, pageSize: number) => {
    setPage(value);
    setSize(pageSize);
  };

  const onSearchOrganizationIdChanged = (data: string) => {
    setSearchOrganizationId(data);
    getDivisionsQuery({ organizationId: data, page, size, search: searchField });
    setPage(1);
  };

  const onSearchFieldChanged = (data: string) => {
    setSearchField(data);
    setPage(1);
  };

  return (
    <>
      <div className={style.search}>
        <DivisionSearchSettings
          organizationId={searchOrganizationId}
          onOrganizationIdChange={onSearchOrganizationIdChanged}
        />
        <Input.Search
          placeholder="Введите название подразделения"
          value={search}
          onSearch={val => onSearchFieldChanged(val)}
          onChange={e => setSearch(e.target.value)}
        />
      </div>
      <Spin spinning={isFetching}>
        <Table
          rowSelection={rowSelection}
          pagination={false}
          columns={columns}
          dataSource={data?.data.map(elem => ({ ...elem, key: elem.id })) || []}
        />
        <div className={style.pagination}>
          <Pagination
            showSizeChanger
            defaultCurrent={1}
            current={page}
            pageSize={size}
            total={data?.pagination.total}
            onChange={(value: number, pageSize: number) => handlePagination(value, pageSize)}
          />
        </div>
      </Spin>
    </>
  );
};

export default DivisionsSearch;
